import { atom } from "recoil";
import { RecoilKeys } from "../../common/miscellaneous/RecoilKeys";

export interface TaskCounterTemplateCriteria {
  companyId: string;
  organizationId: string;
  jobTitle: string;
}

export interface TaskCounterTemplateSearchState {
  criteria: TaskCounterTemplateCriteria;
  hasSearched: boolean;
}

export const defaultTaskCounterTemplateCriteria: TaskCounterTemplateCriteria = {
  companyId: "",
  organizationId: "",
  jobTitle: "",
};

export const defaultTaskCounterTemplateSearchState: TaskCounterTemplateSearchState = {
  criteria: defaultTaskCounterTemplateCriteria,
  hasSearched: false,
};

export const taskCounterTemplateSearchAtom = atom<TaskCounterTemplateSearchState>({
  key: RecoilKeys.TaskCounterTemplateSearch,
  default: defaultTaskCounterTemplateSearchState,
});
